export default "__VITE_ASSET__BjXqO19k__"